import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { teamMemberInfo } from "../../../redux/teamSlice.ts";
import { Loader } from "../../../components/loader/index.js";
import { AddBtn } from "../../../components/addBtn/index.js";
import { Breadcrumbs } from "../../../components/breadcrumbs/index.jsx";

export const TeamInfo = () => {
	const { id } = useParams();
	const { memberInfo, isLoading } = useSelector((store) => store.team);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(teamMemberInfo(id));
	}, [id]);

	return (
		<>
			<Breadcrumbs
				breadcrumbs={[
					{ name: "Our Team", link: "/contents/team" },
					{ name: "Details", link: "" },
				]}
			/>

			{isLoading?.memberInfo ? (
				<div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
					<Loader w="20" h="20" color="orange" />
				</div>
			) : (
				<div className="lg:px-[55px] px-4 py-5 relative">
					<div className="overflow-x-auto w-full">
						<table className="min-w-full text-sm text-left rtl:text-right text-black shadow-md rounded-lg overflow-hidden">
							<tbody className="divide-y divide-gray-200">
								<tr>
									<th className="px-4 py-3 font-medium text-gray-900 whitespace-nowrap w-1/3">
										ID
									</th>
									<td className="px-4 py-3 w-2/3">{memberInfo?.id}</td>
									<td className="px-4 py-3 text-right whitespace-nowrap">
										<AddBtn
											to={`/contents/team/edit/${memberInfo?.id}`}
											text="Edit Details"
										/>
									</td>
								</tr>
								<tr>
									<th className="px-4 py-3 font-medium text-gray-900">Name</th>
									<td className="px-4 py-3" colSpan={2}>{memberInfo?.name}</td>
								</tr>
								<tr>
									<th className="px-4 py-3 font-medium text-gray-900">Title</th>
									<td className="px-4 py-3" colSpan={2}>{memberInfo?.title}</td>
								</tr>
								<tr>
									<th className="px-4 py-3 font-medium text-gray-900">Description</th>
									<td className="px-4 py-3" colSpan={2}>
										<div dangerouslySetInnerHTML={{ __html: memberInfo?.description }} />
									</td>
								</tr>
								<tr>
									<th className="px-4 py-3 font-medium text-gray-900">Quote</th>
									<td className="px-4 py-3" colSpan={2}>{memberInfo?.quote}</td>
								</tr>
								<tr>
									<th className="px-4 py-3 font-medium text-gray-900">Order By</th>
									<td className="px-4 py-3" colSpan={2}>{memberInfo?.order_by}</td>
								</tr>
								<tr>
									<th className="px-4 py-3 font-medium text-gray-900">LinkedIn</th>
									<td className="px-4 py-3" colSpan={2}>
										<a href={memberInfo?.linkedin} className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">
											{memberInfo?.linkedin}
										</a>
									</td>
								</tr>
								<tr>
									<th className="px-4 py-3 font-medium text-gray-900">Active</th>
									<td className="px-4 py-3" colSpan={2}>
										{memberInfo?.is_active === 1 ? "True" : "False"}
									</td>
								</tr>
								{memberInfo?.image_path && (
									<tr>
										<th className="px-4 py-3 font-medium text-gray-900">Image</th>
										<td className="px-4 py-3" colSpan={2}>
											<img
												src={memberInfo.image_path}
												alt={memberInfo.name ? `${memberInfo.name} profile` : "team member"}
												className="w-12 h-12 object-cover rounded-full"
											/>
										</td>
									</tr>
								)}
								<tr>
									<th className="px-4 py-3 font-medium text-gray-900">Created At</th>
									<td className="px-4 py-3" colSpan={2}>
										{memberInfo?.created_at?.slice(0, 10)}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			)}
		</>
	);
};
